import {Component, OnDestroy, OnInit, Input, OnChanges, SimpleChanges, Injector} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventManager, AccountService } from 'src/app/core';
import { ToastrService } from 'ngx-toastr';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ProductService } from '../../product.service';
import { ManageComponent } from 'src/app/shared/components/manage.component';
@Component({
  selector: 'app-dividend-list',
  templateUrl: './dividend-list.component.html',
  styleUrls: ['./dividend-list.component.scss']
})
export class DividendListComponent extends ManageComponent implements OnInit {
  @Input() title: any;
  @Input() list?: any[];
  @Input() queryParams: any = {};
  @Input() searchParams: any = {};
  constructor(
  public injector: Injector,
    public eventManager: EventManager,
    public router: Router,
    private toastService: ToastrService,
    protected productService: ProductService,
    public modalService: NzModalService
  ) {
    super(eventManager, modalService);
  }
  ngOnInit(): void {
    super.ngOnInit();
    this.executeCallAPI();
  }
  loadAll(req?: any) {
    req = req || this.queryParams;
    this.list = [];
    return this.productService.getListDivident(req)
    .subscribe(this.onResponse.bind(this));
  }
  afterSuccess(response) {
    this.list.forEach((item) => {
      (item.productNavInDtoList || []).forEach((product) => {
        if (product.percent <= 96 || product.percent >= 104) {
          product.isHighligt = true;
        }
      })
    });
  }
  create() {
    this.router.navigate(['/products/dividend/create']);
  }
  edit(id) {
    this.router.navigate(['/products/dividend/edit/' + id]);
  }
  delete() {
    this.productService.deleteProductDividend(this.selectedItem.id)
    .subscribe((res) => {
      this.toastService.success('Xoá cổ tức Thành Công !');
      this.eventManager.broadcast({
        name: 'load-page',
        content: {
          page:  this.queryParams.page
        }
      });
    });
  }
  confirmDelete(selectedItem) {
    this.confirmAction(selectedItem, `Bạn chắc chắn muốn xóa cổ tức này : ${selectedItem.productId.name}`, this.delete.bind(this));
  }
}
